export default {
  'analyticalDatasetsList.breadcrumbs.projects': 'Projects',
  'analyticalDatasetsList.breadcrumbs.current': 'Analytical datasets',

  'analyticalDatasetsList.pageHeader.title': 'Analytical datasets',
  'analyticalDatasetsList.pageHeader.createButton': 'Create analytical dataset',

  'analyticalDatasetsList.column.name': 'Name',
  'analyticalDatasetsList.column.status': 'Status',
  'analyticalDatasetsList.column.owner': 'Owner',
  'analyticalDatasetsList.column.modifiedOn': 'Last modified',

  'analyticalDatasetsList.empty': 'No analytical datasets yet. Create one to get started.',
  'analyticalDatasetsList.errorTitle': 'Error',
  'analyticalDatasetsList.error': 'An error occurred while fetching analytical datasets.',

  'analyticalDatasetsList.createModal.title': 'Create analytical dataset',
  'analyticalDatasetsList.createModal.name.label': 'Analytical dataset name',
  'analyticalDatasetsList.createModal.name.placeholder': 'Enter an analytical dataset name',
  'analyticalDatasetsList.createModal.maxCharacterErrorMsg': 'Name must be 60 characters or fewer.',
  'analyticalDatasetsList.createModal.saveButton': 'Create analytical dataset',
  'analyticalDatasetsList.createModal.cancelButton': 'Cancel',
  'analyticalDatasetsList.createModal.closeButton': 'Close',
  'analyticalDatasetsList.createModal.submitting': 'Creating analytical dataset',
  'analyticalDatasetsList.createModal.submittingError': 'Error creating analytical dataset',
  'analyticalDatasetsList.createModal.success.title': 'Success',
  'analyticalDatasetsList.createModal.success.text':
    '“{name}” analytical dataset has been created.',

  'analyticalDatasetsList.duplicateNameError':
    'An analytical dataset with this name already exists in this project.',

  'analyticalDatasetsList.actionMenu.rename.label': 'Rename analytical dataset',
  'analyticalDatasetsList.actionMenu.copy.label': 'Copy analytical dataset',
  'analyticalDatasetsList.actionMenu.delete.label': 'Delete analytical dataset',
  'analyticalDatasetsList.actionMenu.delete.inProgress':
    'Cannot delete while generation is in progress.',

  'analyticalDatasetsList.copyModal.title': 'Copy analytical dataset',
  'analyticalDatasetsList.copyModal.name.label': 'Analytical dataset name',
  'analyticalDatasetsList.copyModal.name.placeholder': 'Enter a name for the copy',
  'analyticalDatasetsList.copyModal.maxCharacterErrorMsg': 'Name must be 60 characters or fewer.',
  'analyticalDatasetsList.copyModal.copyButton': 'Copy analytical dataset',
  'analyticalDatasetsList.copyModal.cancelButton': 'Cancel',
  'analyticalDatasetsList.copyModal.closeButton': 'Close',
  'analyticalDatasetsList.copyModal.submitting': 'Copying analytical dataset',
  'analyticalDatasetsList.copyModal.submittingError': 'Error copying analytical dataset',
  'analyticalDatasetsList.copyModal.success.title': 'Success',
  'analyticalDatasetsList.copyModal.success.text': '“{name}” was copied successfully.',

  'analyticalDatasetsList.renameModal.title': 'Rename analytical dataset',
  'analyticalDatasetsList.renameModal.name.label': 'Analytical dataset name',
  'analyticalDatasetsList.renameModal.name.placeholder': 'Enter an analytical dataset name',
  'analyticalDatasetsList.renameModal.maxCharacterErrorMsg': 'Name must be 60 characters or fewer.',
  'analyticalDatasetsList.renameModal.renameButton': 'Rename analytical dataset',
  'analyticalDatasetsList.renameModal.cancelButton': 'Cancel',
  'analyticalDatasetsList.renameModal.closeButton': 'Close',
  'analyticalDatasetsList.renameModal.submitting': 'Renaming analytical dataset',
  'analyticalDatasetsList.renameModal.submittingError': 'Error renaming analytical dataset',
  'analyticalDatasetsList.renameModal.success.title': 'Success',
  'analyticalDatasetsList.renameModal.success.text': '“{name}” was renamed successfully.',

  'analyticalDatasetsList.deleteModal.title': 'Delete analytical dataset',
  'analyticalDatasetsList.deleteModal.confirmTitle': 'Delete analytical dataset',
  'analyticalDatasetsList.deleteModal.actionUndone': 'This action cannot be undone.',
  'analyticalDatasetsList.deleteModal.description':
    '“{name}” and all its generation run history and results will be permanently deleted.',
  'analyticalDatasetsList.deleteModal.deleteButton': 'Delete analytical dataset',
  'analyticalDatasetsList.deleteModal.cancelButton': 'Cancel',
  'analyticalDatasetsList.deleteModal.closeButton': 'Close',
  'analyticalDatasetsList.deleteModal.submitting': 'Deleting analytical dataset',
  'analyticalDatasetsList.deleteModal.submittingError': 'Error deleting analytical dataset',
  'analyticalDatasetsList.deleteModal.success.title': 'Success',
  'analyticalDatasetsList.deleteModal.success.text': '“{name}” was deleted successfully.',

  'analyticalDatasetDetail.versionResolver.errorTitle': 'Could not load analytical dataset.',
  'analyticalDatasetDetail.versionResolver.errorBody':
    'The analytical dataset could not be resolved.',
  'analyticalDatasetDetail.versionResolver.backToProjects': 'Back to projects',

  'analyticalDatasetDetail.fallbackTitle': 'Analytical dataset',
  'analyticalDatasetDetail.processButton': 'Process',
  // TODO: cleanup with skip_process_confirmation_modal ff
  'analyticalDatasetDetail.processButton.queuing': 'Queuing…',
  // TODO: cleanup with skip_process_confirmation_modal ff
  'analyticalDatasetDetail.processError':
    'The analytical dataset could not be processed. Please try again.',
  'analyticalDatasetDetail.tabsAriaLabel': 'Analytical dataset detail tabs',
  'analyticalDatasetDetail.tabs.definition': 'Definition',
  'analyticalDatasetDetail.tabs.results': 'Results',

  'analyticalDatasetDetail.definition.placeholderTitle': 'Definition coming soon',
  'analyticalDatasetDetail.definition.placeholderBody':
    'Source cohorts, study period, and analytical variables will live here.',
  'analyticalDatasetDetail.definition.stagedChangesWarning':
    'You have unsaved changes to the analytical dataset definition. These results may be out of sync with the current definition.',
  // TODO: cleanup with asset_edit_while_in_use ff
  'analyticalDatasetDetail.definition.staleAnalyticalVariablesWarning':
    'One or more analytical variables used in this analytical dataset have changed since it was last processed. Reprocess to update your results.',
  // TODO: cleanup with asset_edit_while_in_use ff
  'analyticalDatasetDetail.definition.staleSourceCohortsWarning':
    'One or more source cohorts used in this analytical dataset have changed since it was last processed. Reprocess to update your results.',
  // TODO: cleanup with asset_edit_while_in_use ff
  'analyticalDatasetDetail.definition.staleAnalyticalVariablesAndCohortsWarning':
    'One or more source cohorts and analytical variables used in this analytical dataset have changed since it was last processed. Reprocess to update your results.',

  'analyticalDatasetDetail.results.notProcessedTitle': 'Analytical dataset not processed',
  'analyticalDatasetDetail.results.notProcessedBody':
    'Process the analytical dataset to generate per-patient results.',
  'analyticalDatasetDetail.results.processingTitle': 'Analytical dataset processing in progress',
  'analyticalDatasetDetail.results.processingBody':
    'Per-patient results will be available once processing is complete.',
  'analyticalDatasetDetail.results.errorTitle': 'Processing error',
  'analyticalDatasetDetail.results.errorBody':
    'The last run ended in an error. Try processing the analytical dataset again.',
  // Lowercase to match MUI's built-in operator labels (is, after, ...).
  'analyticalDatasetDetail.results.filterBetweenLabel': 'between',
  'analyticalDatasetDetail.results.filterBetweenFrom': 'From',
  'analyticalDatasetDetail.results.filterBetweenTo': 'To',
  'analyticalDatasetDetail.results.filterBetweenInvalidRange': 'Must be on or after From',

  'analyticalDatasetDetail.meta.typeLabel': 'Type:',
  'analyticalDatasetDetail.meta.typeValue': 'Analytical dataset',
  'analyticalDatasetDetail.meta.ownerLabel': 'Owner:',
  'analyticalDatasetDetail.meta.lastModifiedLabel': 'Last modified:',

  'analyticalDatasetDetail.sourceCohorts.label': 'Source cohorts',
  'analyticalDatasetDetail.sourceCohorts.addButton': 'Add cohort',
  'analyticalDatasetDetail.sourceCohorts.removeButton': 'Remove cohort',
  'analyticalDatasetDetail.sourceCohorts.emptyTitle': 'No source cohorts selected',
  'analyticalDatasetDetail.sourceCohorts.emptyBody':
    'Add one or more cohorts to define the analytical dataset population.',
  // TODO: cleanup with av_edit_while_in_use ff
  'analyticalDatasetDetail.sourceCohorts.staleWarning':
    'One or more analytical variables used in this cohort have changed since it was last processed. Reprocess to update your results.',

  'analyticalDatasetDetail.addCohortModal.addTitle': 'Add cohort',
  'analyticalDatasetDetail.addCohortModal.selectHeading': 'Select a cohort ({count})',
  'analyticalDatasetDetail.addCohortModal.searchPlaceholder': 'Search cohorts…',
  // No longer PROCESSED-only — a DRAFT cohort is selectable too (gated by
  // `asset_edit_while_in_use`; the filter, not this copy, enforces it).
  'analyticalDatasetDetail.addCohortModal.empty': 'No cohorts available in this project.',
  'analyticalDatasetDetail.addCohortModal.noResults': 'No cohorts match your search.',
  'analyticalDatasetDetail.addCohortModal.subjects':
    '{count, plural, =0 {No subjects} other {{count, number} subjects}}',
  'analyticalDatasetDetail.addCohortModal.addConfirm': 'Add',
  'analyticalDatasetDetail.addCohortModal.cancel': 'Cancel',

  'analyticalDatasetDetail.studyPeriod.label': 'Study period',
  'analyticalDatasetDetail.studyPeriod.dateRangeLabel': 'Date range',
  'analyticalDatasetDetail.studyPeriod.notSetTitle': 'No study period defined',
  'analyticalDatasetDetail.studyPeriod.notSetHint': 'Inherited from the selected cohort.',
  'analyticalDatasetDetail.studyPeriod.inheritedFrom': 'Inherited from {name}',

  'analyticalDatasetDetail.variables.label': 'Analytical variables',
  'analyticalDatasetDetail.variables.addButton': 'Add variable',
  'analyticalDatasetDetail.variables.defaultChip': 'Default',
  'analyticalDatasetDetail.variables.empty':
    'No analytical variables selected yet. Add one to include it in the analytical dataset.',

  'analyticalDatasetDetail.variables.defaultPatientId.name': 'Patient ID',
  'analyticalDatasetDetail.variables.defaultPatientId.description':
    'Unique patient identifier used for linking records across data sources',

  'analyticalDatasetDetail.variables.defaultIndexDate.name': 'Index date',
  'analyticalDatasetDetail.variables.defaultIndexDate.description':
    'The qualifying date that defines cohort entry for each patient',

  'analyticalDatasetDetail.addVariableModal.title': 'Add analytical variables',
  'analyticalDatasetDetail.addVariableModal.confirm':
    '{count, plural, =0 {Add} one {Add variable} other {Add {count, number} variables}}',
  'analyticalDatasetDetail.addVariableModal.cancel': 'Cancel',

  'analyticalDatasetDetail.stagedChanges.unsaved': 'Unsaved changes',
  'analyticalDatasetDetail.stagedChanges.revert': 'Revert',
  'analyticalDatasetDetail.stagedChanges.save': 'Save',

  'analyticalDatasetDetail.saveModal.title': 'Saving analytical dataset',
  'analyticalDatasetDetail.saveModal.loadingTitle': 'Saving changes',
  'analyticalDatasetDetail.saveModal.loadingText':
    'Saving the latest analytical dataset definition. Do not close this window.',
  'analyticalDatasetDetail.saveModal.errorTitle': 'Save failed',
  'analyticalDatasetDetail.saveModal.errorText':
    'The analytical dataset could not be saved. Please try again.',
  'analyticalDatasetDetail.saveModal.retryButton': 'Retry',

  'analyticalDatasetDetail.processModal.title': 'Process analytical dataset',
  'analyticalDatasetDetail.processModal.confirmTitle': 'Confirm processing of analytical dataset',
  'analyticalDatasetDetail.processModal.message1':
    'This action will save the analytical dataset and queue it for processing.',
  'analyticalDatasetDetail.processModal.message2':
    'The analytical dataset status will be updated from {fromStatus} to {processing}.',
  'analyticalDatasetDetail.processModal.message3':
    'Once processing is complete, the status will be updated to {processed} and the results will be available.',
  'analyticalDatasetDetail.processModal.draft': 'Draft',
  'analyticalDatasetDetail.processModal.processing': 'Processing',
  'analyticalDatasetDetail.processModal.ready': 'Ready',
  'analyticalDatasetDetail.processModal.confirmButton': 'Confirm',
  'analyticalDatasetDetail.processModal.errorTitle': 'Application Error',
  'analyticalDatasetDetail.processModal.errorText':
    'The analytical dataset could not be processed. Please try again.',
  'analyticalDatasetDetail.processModal.retryButton': 'Retry',
  'analyticalDatasetDetail.processModal.successTitle': 'Success',
  'analyticalDatasetDetail.processModal.successText':
    '"{name}" has been saved and processing was queued successfully.',
  'analyticalDatasetDetail.processModal.successCountdown':
    'This window will close automatically in {count, plural, one {# second} other {# seconds}}.',
  'analyticalDatasetDetail.processModal.fallbackName': 'Analytical dataset',
  'analyticalDatasetDetail.processTooltip.noCohort': 'Add a source cohort to process.',
  'analyticalDatasetDetail.processTooltip.processing': 'Processing analytical dataset…',
  'analyticalDatasetDetail.processTooltip.notOwner':
    'Only the owner can process this analytical dataset.',
  'analyticalDatasetDetail.processTooltip.cohortNotProcessed':
    'The source cohort must finish processing before this analytical dataset can be processed.',

  'analyticalDatasetDetail.editLock.processing':
    'Editing is disabled while the analytical dataset is processing.',
  'analyticalDatasetDetail.editLock.notOwner': 'Only the owner can edit this analytical dataset.',

  'analyticalDatasetDetail.downloadButton': 'Download results',
  'analyticalDatasetDetail.downloadTooltip.notProcessed':
    'Process the analytical dataset to enable downloads.',
  'analyticalDatasetDetail.downloadTooltip.inFlight':
    'Download in progress. Your files will save automatically when ready.',
  'analyticalDatasetDetail.downloadModal.title': 'Download results',
  'analyticalDatasetDetail.downloadModal.loadingTitle': 'Preparing download',
  'analyticalDatasetDetail.downloadModal.loadingText':
    'Your analytical dataset and data dictionary will download automatically once ready. You can close this window and it will continue in the background.',
  'analyticalDatasetDetail.downloadModal.errorTitle': 'Download failed',
  'analyticalDatasetDetail.downloadModal.errorText':
    'The export could not be downloaded. Please try again.',
  'analyticalDatasetDetail.downloadModal.retryButton': 'Retry',

  'analyticalDatasetDetail.revertModal.title': 'Reverting changes',
  'analyticalDatasetDetail.revertModal.loadingTitle': 'Reverting changes',
  'analyticalDatasetDetail.revertModal.loadingText':
    'Restoring the analytical dataset to its last saved state.',
};
